module.exports = __webpack_public_path__ + "static/media/atamd.5568a246.jpg";